'use strict';

(function ($) {
  $(function () {
    // Check for minimum length
    Foundation.Abide.defaults.validators['min_length'] = function ($el, required, parent) {
      // parameter 1 is jQuery selector
      if (!required) return true;
      var min = $el.data('min-length'),
          val = $el.val();

      return parseInt(val.length) >= parseInt(min);
    };

    $(document).foundation();

    var App = {

      data: {
        formSuccess: '.form-success',
        formError: '.form-error',
        formContent: '.form-content',
        formContentText: '.form-content__text',
        hide: 'hide',
        overlay: 'overlay'
      },

      _initApp: function () {
        this._modal();
        this._form();
        this._startSliderMain();
        this._startLightGallery();
        this._changeTabsGallery();
        this._startSliderClients();
        this._startSliderReviews();
      },
      _reflowApp: function () {
        this._modal();
        this._form();
      },


      // Modals
      _modal: function () {
        var $modal = $('#modalAjax');
        var $content = $('#modalContentAjax');

        $('[data-modal]').off('click').on('click', function (e) {
          e.preventDefault();

          App.hideBlock($content);
          App.addLoading($content, 'large');
          $modal.foundation('open');

          $.ajax({
            url: $(e.currentTarget).data('modal')
          }).done(function (resp) {
            $content.empty().html(resp).foundation();
            App._reflowApp();
            App.removeLoading($content);
            App.showBlock($content);
          });
        });
      },


      // Form Validation
      _form: function () {
        var $form = $('[data-abide]');

        $form.on('submit.zf.abide', function (e) {
          e.preventDefault();
        }).on('formvalid.zf.abide', function (e) {
          var $target = $(e.currentTarget);

          // Включаем анимацию и перекрытие
          App.addLoading($target);
          App.addOverlay($target);
          // Скрываем блок с ошибкой формы
          App.hideBlock($target.find(App.data.formError));

          // Метод бекенда для отправки данных
          App.appMethod($target.data('backend'), $target);
        });
      },


      // Запуск backend-метода
      appMethod: function (method, event) {
        if (method in App) {
          event ? App[method](event) : App[method]();
        } else {
          method ? console.log("Backend action: ", method) : console.log("Not method");
        }
      },


      // Function for created loading
      addLoading: function (obj, size) {
        var spinner = 'spinner';
        size ? spinner += ' spinner--' + size : spinner;
        if (obj.hasClass('btn')) {
          obj.addClass('btn--loading');
          obj.wrapInner('<span class="btn__text"></span>');
          obj.prepend('<div class="' + spinner + '"><div class="spinner__circle"></div></div>');
        } else {
          obj.wrap('<div class="spinner-mask spinner-mask--start" style="min-height: 200px"></div>').parent().prepend('<div class="' + spinner + '"><div class="spinner__circle"></div></div>');
        }
      },
      // Function for deleted loading
      removeLoading: function (obj) {
        if (obj.hasClass('btn')) {
          obj.removeClass('btn--loading').find('btn__text').unwrap();
        } else {
          obj.parent().find('.spinner').remove();
          obj.unwrap();
        }
      },
      // Add to Overlay
      addOverlay: function (obj) {
        obj.addClass(App.data.overlay);
      },
      // Remove to Overlay
      removeOverlay: function (obj) {
        obj.removeClass(App.data.overlay);
      },
      // Hide block
      hideBlock: function (obj) {
        obj.addClass(App.data.hide);
      },
      // Show block
      showBlock: function (obj) {
        obj.removeClass(App.data.hide);
      },
      // Show Error Form
      setErrorForm: function (obj, message) {
        var formError = obj.find(App.data.formError);
        formError.find(App.data.formContentText).empty().html(message);
        App.showBlock(formError);
      },

      // Slider Main to header in index-page
      _startSliderMain: function () {
        if ($('.js-slider-main').length) {
          tns({
            container: '.js-slider-main',
            items: 1,
            slideBy: 'page',
            autoplay: false,
            autoplayButtonOutput: false,
            nav: true,
            controls: true,
            navPosition: 'bottom',
            //navContainer: '.js-slider-main .page-header__slider-nav',
            controlsContainer: ".tiny-slider-controls"
          });
        }
      },

      // Gallery
      _startLightGallery: function () {
        $('.js-gallery').lightGallery({
          selector: '.js-gallery-item',
          download: false,
          fullScreen: false,
          autoplay: false,
          autoplayControls: false,
          share: false
        });
      },

      // При переключении табов в разделе Наши работы
      _changeTabsGallery: function () {
        $('#gallery-tabs').on("change.zf.tabs", function (e, target) {
          var $panel = $($(target).find("a").attr("href"));

          $panel.empty();
          App.addLoading($panel);

          $.ajax({ url: $(target).data('ajax') }).done(function (resp) {
            $panel.empty().html(resp);
            App._startLightGallery();
            App.removeLoading($panel);
          });
        });
      },

      // Slider Clients in index-page
      _startSliderClients: function () {
        if ($('.js-slider-clients').length) {
          var params = {
            container: '.js-slider-clients',
            slideBy: 'page',
            items: 4,
            autoplay: false,
            autoWidth: true,
            autoplayButtonOutput: false,
            loop: true,
            //"rewind": true,
            nav: false,
            controls: true,
            center: false,
            navPosition: 'bottom',
            controlsContainer: ".tiny-slider-controls-clients"
          };
          if (document.documentElement.clientWidth > 1020) tns(params);else {
            params.autoWidth = false;
            params.fixedWidth = 250;
            params.center = true;
            params.mouseDrag = true;
            if (document.documentElement.clientWidth > 576) params.items = 2;else params.items = 1;

            tns(params);
          }
        }
      },

      // Slider Reviews in index-page
      _startSliderReviews: function () {
        if ($('.js-slider-reviews').length) {
          var params = {
            container: '.js-slider-reviews',
            items: 3,
            autoWidth: false,
            fixedWidth: 350,
            loop: true,
            center: true,
            slideBy: 'page',
            autoplay: false,
            autoplayButtonOutput: false,
            nav: false,
            controls: true,
            navPosition: 'bottom',
            controlsContainer: ".tiny-slider-controls-reviews"
          };

          if (document.documentElement.clientWidth > 1020) tns(params);else {
            params.fixedWidth = 280;
            params.center = true;
            params.mouseDrag = true;
            params.items = 1;

            tns(params);
          }
        }
      }
    };

    App._initApp();
    window.App = App;
  });
})(jQuery);